var map = {
	"./01.svg": 63997,
	"./02.svg": 26174,
	"./03.svg": 88751,
	"./04.svg": 22864,
	"./05.svg": 35105,
	"./06.svg": 30066,
	"./07.svg": 84355
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 60890;